export default function($) {
  $('.js-show-password').on('click', function(event) {
    event.preventDefault();

    var target = $(this).data('target');
    var $target = $("#" + target);

    var $label_show = $(this).children('.js-show-password--show');
    var $label_hide = $(this).children('.js-show-password--hide');

    if ($target.attr('type') == 'password') {
      $target.attr('type', 'text');
      $label_show.hide();
      $label_hide.show();
      $(this).attr('aria-label', $label_hide.data('label'));
    } else {
      $target.attr('type', 'password');
      $label_hide.hide();
      $label_show.show();
      $(this).attr('aria-label', $label_show.data('label'));
    }
  });
}
